<!-- title -->
<app-modal-title
  [title]="'common.filters' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div
  mat-dialog-content
  class="dialog-content tw-text-xl tw-text-center tw-mb-1 dark:tw-bg-dark-600"
>
  <div class="tw-w-[700px] tw-text-[1.1rem]">
    <div
      class="row card-header dialog-dark dark:tw-bg-dark-600"
      *ngFor="let formul of textParserFormula; let i = index"
    >
      <!-- if Condition -->
      <div class="tw-w-1/2">
        <app-text-parser-if-condition-modal
          [ifConditionType]="formul.ifConditionType"
          [ifConditionValue]="formul.ifConditionValue"
          [ifConditionTypeEnumValues]="TextParserIfConditionTypesEnumValues"
        >
        </app-text-parser-if-condition-modal>
      </div>

      <!-- then Condition -->
      <div class="tw-w-1/2">
        <app-text-parser-then-condition-modal
          [thenConditionType]="formul.thenConditionType"
          [ifConditionType]="formul.ifConditionType"
          [thenConditionValue]="formul.thenConditionValue"
          [thenConditionTypeEnumValues]="TextParserThenConditionTypeEnumValues"
          [smsSentPeriodTypeEnumValues]="SmsSentPeriodTypeEnumValues"
        >
        </app-text-parser-then-condition-modal>
      </div>

      <!-- form btns-->
      <section class="">
        <div class="tw-flex tw-justify-center">
          <div class="tw-flex tw-justify-end tw-h-[70%] tw-w-full">
            <mat-slide-toggle
              [checked]="isChecked[i]"
              (change)="onChooseFormula(formul.id, i)"
              mat-ripple
            >
              <app-expand-text [placement]="'right'">
                <span small-text>
                  {{ "common.selectFilter" | translate }}
                </span>
              </app-expand-text>
            </mat-slide-toggle>
          </div>
        </div>
      </section>
    </div>
  </div>

  <!-- form btns-->
  <app-form-btns
    [customTitle]="'common.confirm' | translate"
    [loading]="false"
    [isEdit]="false"
    (onClose)="onClose()"
    (onSubmit)="onConfirm()"
  >
  </app-form-btns>
</div>
